'use strict';


jQuery(document).ready(function () {
  var $ = jQuery;


  $('#supplierResultGridView').on('click', function () {
    $('#supplierResultListView').toggleClass("show");
    $("#supplierResultGridView").toggleClass("show");

    $('#supplierResultContent').removeClass('org-card__list');
    $('#supplierResultContent').addClass('org-card__grid');
  });
  $('#supplierResultListView').on('click', function () {
    $('#supplierResultListView').toggleClass("show");
    $("#supplierResultGridView").toggleClass("show");

    $('#supplierResultContent').removeClass('org-card__grid');
    $('#supplierResultContent').addClass('org-card__list');
  });

  function renderLatestSearch() {
    var oldItems = JSON.parse(localStorage.getItem('latestSearchSupplier')) || [];
    var htmlElement = [];

    oldItems.forEach(function (item) {
      htmlElement.push('<a href="' + item[1] + '" class="search-filter__latest-search de-capitate">' + item[0] + '</a>');
    });

    $('#latestSearchSupplier').html('' + htmlElement.join(''));
  }
  renderLatestSearch();

  // ====================
  // Ajax get posts
  // ====================

  var $content = $('#supplierResultContent');
  var category = [];
  var categoryNames = [];
  var county = [];
  var search = '';
  var order = '1';

  searchHasValue();
  countyIsChecked();
  categoryIsChecked();

  var getContent = function getContent() {
    var first = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    $.ajax({
      type: "POST",
      dataType: "html",
      data: {
        category: category,
        county: county,
        search: search,
        order: order
      },
      url: templateUrl  + "/functions/supplier-page-query.php",
      beforeSend: function beforeSend() {
        $content.text("");
        $content.prepend(
          "<div class='fishy-title'><h1>Laster...</h1></div><div class='fishy-content'><div class='background'></div></div>"
        );
      },
      success: function  success(data) {
        
        $content.html(data);
        var currentUrl = window.location.search;
        currentUrl = '?' + currentUrl.substring(currentUrl.indexOf("?") + 1);
        var urlParameters = first ? currentUrl : createUrlParameters();
        window.history.pushState("", "", urlParameters);
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log(jqXHR + " :: " + textStatus + " :: " + errorThrown);
      }
    });
  }; // END getMovies

  getContent();

  $('.category-supplier').on('click', function () {
    category = [];
    categoryNames = [];
    categoryIsChecked();
    getContent(false);
  });

  $('.county-supplier').on('click', function () {
    county = [];
    countyIsChecked();
    getContent(false);
  });
  $('#search-supplier-btn').on('click', function () {
    search = $('#search-supplier').val();
    getContent(false);
  });
  $('#search-supplier').keypress(function (e) {
    if (e.which == 13) {
      search = $('#search-supplier').val();
      getContent(false);
    }
  });

  $('#searchOrderBy').on('change', function () {
    order = $(this).val();
    getContent(false);
  });

  function categoryIsChecked() {
    $('.category-supplier').each(function () {
      var checked = $(this).is(':checked');
      if (checked) {
        category.push($(this).val());
        console.log('names', $(this).data('name'));
        categoryNames.push($(this).data('name'));
      }
    });
  }

  function countyIsChecked() {
    $('.county-supplier').each(function () {
      var checked = $(this).is(':checked');
      if (checked) {
        county.push($(this).val());
      }
    });
  }

  function searchHasValue() {
    search = $('#search-supplier').val();
  }

  function orderByIsChecked() {
    var orderSelect = document.getElementById('searchOrderBy');
    var orderOption = orderSelect.options[orderSelect.selectedIndex].value;
    order = orderOption;
  }

  function dateIsSet() {
    fromDate = $('[data-toggle="datepickerStart"]').datepicker('getDate', true);
    console.log('fromDate', fromDate);
    toDate = $('[data-toggle="datepickerEnd"]').datepicker('getDate', true);
  }

  function createUrlParameters() {
    var url = "?";
    var prevSearch = "";

    if (search !== '') {
        url += 'search=' + search + '&';
        prevSearch += '"' + search + '" + ';
    }
    if (category.length > 0) {
        url += 'cat=' + category.toString() + '&';
        prevSearch += '' + categoryNames.join(', ') + ' + ';
    }
    if (county.length > 0) {
        url += 'county=' + county.toString() + '&';
        prevSearch += '' + county.join(', ') + ' + ';
    }

    url += 'order=' + order.toString();

    var storedPrevSearches = JSON.parse(localStorage.getItem('latestSearchSupplier')) || [];
    if (storedPrevSearches.length >= 3) {
      storedPrevSearches.pop();
    }
    var prevSearchWithoutLastPlusSign = prevSearch.toString().slice(0, -2);
    storedPrevSearches.unshift([prevSearchWithoutLastPlusSign, url]);
    localStorage.setItem('latestSearchSupplier', JSON.stringify(storedPrevSearches));
    renderLatestSearch();

    return url;
  }

 
});



